import type { FaireProductEntity } from "../../entity_types/product";

export const p_u24uamt3xs: FaireProductEntity = {
  token: "p_u24uamt3xs",
  type: "product",
  name: "Magnesium Bath Soak",
  brandToken: "b_rbtpks7s3j",
  brandName: "Whispering Wellness Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/b2862fde5d901f7924141bbbd8fff427b902457893e99b48380ac355c40ad2b2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c8205bd4c798ca43edd5795fcd3fdf53bcf87d96b734ae76ed4ee3e62e0a464a.jpeg",
    "https://cdn.faire.com/fastly/bace8c0b96008ad720287522cbc4dfdb8319f5979a2337b76ee1d7d03851e629.jpeg",
    "https://cdn.faire.com/fastly/705d274f2b44ffb05396c579e93e52a8f4765efe43b72a527bb928818daff2f0.jpeg",
    "https://cdn.faire.com/fastly/bb2ce691de6c43d83301bb38708e6810059ae63096d591e5cfd2041fecef89c9.jpeg",
    "https://cdn.faire.com/fastly/dcf98b971a337d7fbda56ac19716c7ac3807c65a8b368607facd2e55a89c1913.jpeg",
  ],
  priceDollars: 4,
  description:
    "Recharge Your Body and Mind with Our Magnesium Bath Soak\n\nOur luxurious Magnesium Bath Soak is designed to relax muscles, calm the mind, and nourish your skin. Infused with Dead Sea magnesium flakes and Pink Himalayan salt, this soothing blend helps melt away tension while replenishing essential minerals.  \n\nAvailable in three delightful scents — Floral, Lavender, and Citrus — each designed to enhance your self-care experience:  \nFloral for a calming, feminine touch  \nLavender for ultimate relaxation  \nCitrus for a refreshing, mood-boosting soak  \n\nPerfect for easing sore muscles, reducing stress, and supporting overall wellness, this soak is your go-to for a rejuvenating self-care ritual. Add to your bath or foot soak and let the calming, skin-loving ingredients work their magic.  \n\nHow to Use:\nAdd a half cup to warm bathwater or one-eighth cup to a foot soak. Relax for twenty to thirty minutes, breathe deeply, and enjoy. ",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:31.695Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
